module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_nordland_pos.57d0e657.svg";